import ReactDOM from 'react-dom/client';
import React from 'react';
import { AssignedUnits } from './assigned-units';
import { DateTime } from 'luxon';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';

export function initAssignedUnits(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('assigned-units');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          if (k === 'assignmentChange') {
            const event = new CustomEvent('assignmentChange');
            element.dispatchEvent(event);
          } else {
            element.setAttribute(k, o[k]);
          }
        });
      };

      const bootstrap = (mutations: MutationRecord[]) => {
        if (
          mutations.length === 0 ||
          mutations.find(
            (r) =>
              (r.attributeName === 'data-quantity' && !element.dataset.orderId) ||
              r.attributeName === 'data-is-blocked' ||
              r.attributeName === 'data-location-id',
          )
        ) {
          const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
          const props = {
            ...dataset,
            quantity: parseInt(dataset.quantity),
            startDate: DateTime.fromISO(dataset.startDate, { setZone: true }),
            endDate: DateTime.fromISO(dataset.endDate, { setZone: true }),
            isBlocked: dataset.isBlocked !== '0',
            orderId: dataset.orderId ? parseInt(dataset.orderId) : undefined,
            orderProductId: dataset.orderProductId ? parseInt(dataset.orderProductId) : undefined,
          };
          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <AssignedUnits {...props} setRootAttributes={setRootAttributes} />
              </TenantContext.Provider>,
            ),
          );
          const event = new CustomEvent('change');
          element.dispatchEvent(event);
        }
      };

      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}
